import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Box } from '@material-ui/core';

export const CheckInCoverageChart = (props) => {
	const { chartData } = props;
	const columnWithGroupedChartData = {
		credits: {
			enabled: false,
		},
		chart: {
			plotBackgroundColor: null,
			plotBorderWidth: 0,
			plotShadow: false,
			margin: [0, 0, 0, 0], // top, right, bottom, left
			height: '90',
		},
		title: {
			text: `${chartData?.checkInCompletionCount}`,
			align: 'center',
			verticalAlign: 'middle',
			y: 35,
			style: {
				fontWeight: 'bold',
				fontSize: '28px',
				fontFamily: 'Lato',
				color: '#292929',
			},
		},
		tooltip: {
			pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
		},
		accessibility: {
			point: {
				valueSuffix: '%',
			},
		},
		plotOptions: {
			pie: {
				// dataLabels: {
				// 	enabled: true,
				// 	distance: -50,
				// 	style: {
				// 		fontWeight: 'bold',
				// 		color: 'white',
				// 	},
				// },
				startAngle: -102,
				endAngle: 102,
				center: ['50%', '100%'],
				size: '230%',
			},
		},
		series: [
			{
				type: 'pie',
				name: 'Check-in Coverage',
				innerSize: '80%',
				enableMouseTracking: false,
				data: [
					{
						name: '',
						y: chartData?.checkInCompletionCount,
						color: '#0CBC74',
						dataLabels: {
							enabled: false,
						},
					},
					{
						name: 'Other',
						y: chartData?.totalWeekCount - chartData?.checkInCompletionCount,
						color: '#D5DAE1',
						dataLabels: {
							enabled: false,
						},
					},
				],
			},
		],
	};

	return (
		<Box className='pie-chart'>
			<HighchartsReact highcharts={Highcharts} options={columnWithGroupedChartData} />
		</Box>
	);
};
